import { Component, OnInit } from '@angular/core'
import { isFunction } from 'lodash'

declare const window: any

@Component({
  selector: 'app-help-widget',
  templateUrl: './help-widget.component.html',
  styleUrls: ['./help-widget.component.scss'],
})
export class HelpWidgetComponent implements OnInit {
  public open = false
  public spin = true
  public direction = 'up'
  public animationMode = 'fling'

  constructor() {}

  ngOnInit() {}

  goToScheduleTraining() {
    window.open('https://calendly.com/tokeet')
  }

  goToHelp() {
    window.open('https://help.tokeet.com')
  }

  goToCommunity() {
    window.open('https://community.tokeet.com/')
  }

  goToTokeetStatus() {
    window.open('https://status.tokeet.com/')
  }

  openChat() {
    if (isFunction(window.Intercom)) {
      window.Intercom('show')
    }
    this.open = false
  }
}
